import { gql } from "graphql-tag";

export const GET_UNRESOLVED_DEDUCTIONS_ANALYTICS = gql`
  query UnresolvedDeductionsAnalytics($startDate: String!, $endDate: String!, $purchaserIds: [Int!]!) {
    unresolvedDeductionsAnalytics(params: { startDate: $startDate, endDate: $endDate, purchaserIds: $purchaserIds }) {
      primaryValue
      secondaryValue
      chipLabel
      footerText
      trend
    }
  }
`;
